let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("f4VOl")).then(() => parcelRequire('5ooqG'));